export function getPendingCompanySignatureDocuments(documents) {
  // Mostra solo i documenti in cui è il turno dell'azienda secondo l'ordine
  // per-template (`can_company_sign`, calcolato dal backend). Fallback per risposte
  // vecchie senza il campo: default company_first, quindi l'azienda può firmare.
  return (documents ?? []).filter((doc) => {
    if (doc.status === 'signed' || !doc.has_company_fields || doc.company_fields_signed) return false;
    return doc.can_company_sign ?? true;
  });
}

export function countPendingCompanySignatureDocuments(documents) {
  return getPendingCompanySignatureDocuments(documents).length;
}
